import { IOrganization } from "@/api";
import { Edit } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useDialogs } from "@toolpad/core";
import { useCallback } from "react";
import { EditOrganizationDialog } from "../dialogs/organization/EditOrganizationDialog";

interface Props {
    organization: IOrganization;
}

export const EditOrganizationButton = ({ organization }: Props) => {
    const dialogs = useDialogs();

    const handleEdit = useCallback(async () => {
        await dialogs.open(EditOrganizationDialog, {
            organization: organization,
        });
    }, [dialogs, organization]);

    return (
        <GridActionsCellItem
            icon={<Edit />}
            label="Edit Organization"
            onClick={handleEdit}
        />
    );
};
